import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";

import Header from "../components/Header";
import StockCallsTable from "../components/StockCallsTable";

function AdminCallsByStatus() {
  const navigate = useNavigate();
  const { status } = useParams();

  const selectedStatus = decodeURIComponent(status || "All");

  const [calls, setCalls] = useState([]);
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");

  const getStatusRank = (callStatus) => {
    switch (callStatus) {
      case "Active":
        return 1;

      case "Target Hit":
        return 2;

      case "Exit":
        return 3;

      case "Stop Loss Hit":
        return 4;

      case "Closed":
        return 5;

      default:
        return 6;
    }
  };

  const fetchCalls = async () => {
    const data = await getDocs(collection(db, "stockCalls"));

    const list = data.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    list.sort((a, b) => {
      const statusA = getStatusRank(a.status);
      const statusB = getStatusRank(b.status);

      if (statusA !== statusB) {
        return statusA - statusB;
      }

      return (b.createdAt || 0) - (a.createdAt || 0);
    });

    setCalls(list);
  };

  useEffect(() => {
    fetchCalls();
  }, []);

  const deleteCall = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this stock call?"
    );

    if (confirmDelete) {
      await deleteDoc(doc(db, "stockCalls", id));
      fetchCalls();
    }
  };

  const editCall = (call) => {
    navigate("/edit-call", {
      state: call,
    });
  };

  const quickUpdateCall = async (id, currentPrice, callStatus) => {
    if (!currentPrice || !callStatus) {
      alert("Please enter CMP and select status.");
      return;
    }

    const callRef = doc(db, "stockCalls", id);

    await updateDoc(callRef, {
      currentPrice: Number(currentPrice),
      status: callStatus,
    });

    alert("✅ CMP and Status Updated");

    fetchCalls();
  };

  const pageTitle =
    selectedStatus === "All"
      ? "All Stock Calls"
      : `${selectedStatus} Calls`;

  return (
    <>
      <Header />

      <Container className="mt-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <Button
              variant="outline-secondary"
              className="mb-3"
              onClick={() => navigate("/admin-dashboard")}
            >
              <FaArrowLeft className="me-2" />
              Back to Dashboard
            </Button>

            <h2 className="fw-bold">
              {pageTitle}
            </h2>

            <p className="text-muted">
              View and manage all calls under this category.
            </p>
          </Col>
        </Row>

        <Card className="shadow border-0 mb-4">
          <Card.Body>
            <Row>
              <Col md={6} className="mb-3">
                <Form.Label>Search Stock</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Search by stock name..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Col>

              <Col md={6} className="mb-3">
                <Form.Label>Call Type</Form.Label>

                <Form.Select
                  value={typeFilter}
                  onChange={(e) => setTypeFilter(e.target.value)}
                >
                  <option>All</option>
                  <option>Long Term</option>
                  <option>Mid Term</option>
                  <option>Short Term</option>
                </Form.Select>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <StockCallsTable
          calls={calls}
          editCall={editCall}
          deleteCall={deleteCall}
          quickUpdateCall={quickUpdateCall}
          search={search}
          typeFilter={typeFilter}
          statusFilter={selectedStatus}
        />
      </Container>
    </>
  );
}

export default AdminCallsByStatus;